export default {
  withdraw_percent_fee: 'percent fee',
  withdraw_fixed_fee: 'fixed fee',
  withdraw_pending: 'Pending',
  withdraw_approve: 'Fulfill',
  withdraw_reject: 'Reject',
  withdraw_created: 'Created',
  withdraw_approved: 'Approved',
  withdraw_cancelled: 'Cancelled',
  withdraw_rejected: 'Rejected',
  withdraw_permanently_rejected: 'Rejected',
  withdraw_withdraw: 'Withdraw',
  withdraw_withdraw_option: 'Choose withdrawal option',
  withdraw_withdrawal: 'Withdrawal',
  withdraw_details: 'Withdrawal details',
  withdraw_confirm: 'Withdrawal confirmation',
  withdraw_how_much: 'Minimum amount is %{value} %{asset}. ',
  withdraw_network_fee: 'Please note, in addition to the amount of withdrawal transaction network fees can be charged.',
  withdraw_insha_fee: 'Minimum amount is 11.00 UAH. Bank commission - 10.00 UAH',
  withdraw_eth_btc: 'Minimum amount is %{value} %{asset}.',
  withdraw_ex_address: 'Withdrawal external address',
  withdraw_to: 'Withdraw to:',
  withdraw_cashbox: 'Cashbox',
  withdraw_ucash: 'UPLATA (ID %{taid})',
  withdraw_uplata_insha: 'Visa Insha (%{uplataInsha})',
  withdraw_xpay: '%{name} (%{mask_pan})',
  withdraw_external: 'Address %{asset}',
  withdraw_nothere: 'Withdrawal is not allowed',
  withdraw_success: 'Withdrawal request successfully created',
  withdraw_reject_reason_prompt: 'Enter the reject reason',
  withdraw_reject_reason_warn: 'Reject reason must not be empty',
  withdraw_request_approved: 'Withdrawal request fulfilled succesfully',
  withdraw_request_rejected: 'Withdrawal request is rejected',
  withdraw_error_is_trying_to_send_to_yourself: 'Sender can\'t be a recipient! Make sure the address is correct',
  withdraw_error_invalid_address: 'Invalid wallet address',
  withdraw_error_insufficient_funds: 'Insufficient funds',
  withdraw_error_minimum_amount: 'The minimum amount is %{value} %{asset}',
  withdraw_error_maximum_amount: 'The maximum amount is %{value} %{asset}',
  withdraw_no_withdrawals: 'No withdrawal requests',
  withdraw_no_withdrawals_desc: 'Here will be the list of withdrawal requests',
  withdraw_no_assets: 'No withdrawable assets in your wallet',
  withdraw_no_assets_exp: 'This feature will be available once you have any withdrawable asset',
  withdraw_amount_round: 'Withdrawal amount will be round down to %{amount} %{asset}',
  withdraw_creation_date: 'Creation date',
  withdraw_updating_date: 'Updating date',
  withdraw_list_tooltip: 'Use mouse double click to open the approval form',
  withdraw_usdt_delay_msg: 'After creating a transaction, please check its status on the transaction list screen, a delay may apply',
  withdraw_usdt_tx_sent: 'Transaction sent',
  withdraw_usdt_tx_sent_automaticly: 'The transaction was sent automatically',
  withdraw_usdt_tx_cancelled: 'The transaction has been cancelled. Your funds will soon return to your wallet',
  withdraw_usdt_tx_cancelled_automaticly: 'You did not have time to cancel the transaction. The transaction was sent automatically'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/withdrawal_view.js